import { timeShift } from "@/utils/util";
import { Table } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useRecordModel } from "../recordModel";

export function DataTable() {
    const { t } = useTranslation();
    const {
        dataSource, pgCfg, loading, loadData,
    } = useRecordModel();

    useEffect(() => {
        loadData()
    }, [])

    const columns = [
        {
            title: t(`paper.view.DataTable.序号`),
            width: 60,
            align: "center",
            fixed: "left",
            render: (text, record, index) => index + 1
        }, {
            title: t(`paper.view.DataTable.创业班组`),
            width: 160,
            dataIndex: 'team',
        }, {
            title: t(`paper.view.DataTable.所属机构`),
            width: 160,
            dataIndex: "org",
        }, {
            title: t(`paper.view.DataTable.答题时间`),
            width: 160,
            dataIndex: "createTime",
            render: (text) => text ? timeShift(text) : "",

        }, {
            title: t(`paper.view.DataTable.成绩`),
            width: 160,
            dataIndex: 'score',
        }
    ];


    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `${t(`paper.view.DataTable.共`)}${pgCfg.total}${t(`paper.view.DataTable.条`)}`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            scroll={dataSource.length ? { x: 'max-content', y: "calc(100vh - 430px)" } : { x: 'max-content' }}
        />
    )
}
